"use client";

import { AnimatePresence, motion } from "framer-motion";
import { useSession } from "next-auth/react";

import { useDashboard } from "@/app/hooks/useDashboard";
import { DashboardSkeleton } from "@/components/dashboard/DashboardSkeleton";
import { DashboardSurface } from "@/components/dashboard/DashboardSurface";
import { PageHeader } from "@/components/shared/PageHeader";
import { crossfadeVariants } from "@/lib/animations";

export default function DashboardPage() {
  const { data: session, status: sessionStatus } = useSession();
  const userId = session?.user?.id ?? null;

  const { data, isLoading } = useDashboard(!!userId);

  const showSkeleton = sessionStatus === "loading" || (!!userId && isLoading);

  return (
    <AnimatePresence mode="wait">
      {showSkeleton ? (
        <motion.div
          key="skeleton"
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={crossfadeVariants}
        >
          <PageHeader />
          <main className="flex min-h-[calc(100dvh-var(--navbar-height))] md:min-h-dvh flex-col">
            <DashboardSkeleton />
          </main>
        </motion.div>
      ) : (
        <motion.div
          key="content"
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={crossfadeVariants}
        >
          <DashboardSurface entries={data?.entries ?? []} todayIso={data?.todayIso ?? ""} />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
